import React, { Component, useEffect, useState } from "react";
import TableComponent from "./common/TableComponent";
import moment from "moment";
import DateBox from "./controls/DateBox";
import Transition from "./common/Transition";
import * as constants from "../constants";
import { DateFormatter } from "./common/DateFormatter";
import { currencyFormat, multiselectFilter } from "./common/commonFns";
import {downloadCSV} from "./common/csvDownload";
import { AgentsRequests } from "../apiRequests/AgentsRequests";
import SearchBox from "./controls/SearchBox";
import MultiSelection from "./controls/MultiSelection";
import Loader from "./common/Loader";

const dateFormatter = new DateFormatter();
const agentsRequests = new AgentsRequests();

function PaymentRecordView(props) {
  const [state, setState] = useState({
    hidden: "hidden",
    isLoaded: false,
    agentId: localStorage.getItem("agentId"),
    tableRows: [],
    tableEmpty: "hidden",
    pCommissionsData: [],
    allPrograms: [],
    allEnrolmentNo: [],
    allTransactionNo: [],
    transactionNoSelectedList: [],
    programsSelectedList: [],
    enrolmentNoSelectedList: [],
    firstRowIndex: 0,
    lastRowIndex: constants.NUMBEROFROWS - 1,
    filterOn: false,
    dataLength: 0,
    searchFieldValue: "",
    isOpen: false,
    expanded: "",
    background: "hidden",
    fromDate: "",
    toDate: "",
  });

  useEffect(() => {
    let startDate = localStorage.getItem("t8StartDate");
    let endDate = localStorage.getItem("t8EndDate");
    setState((prevState) => ({
      ...prevState,
      fromDate: startDate,
      toDate: endDate,
    }));
  }, []);

  useEffect(() => {
    if (state.fromDate && state.toDate) {
      paidCommissionsFn(state.fromDate, state.toDate);
    }
  }, [state.toDate, state.fromDate]);
  useEffect(() => {
    loadMultiSelectData();
  }, [state.pCommissionsData]);

  useEffect(() => {
    loadData();
  }, [
    state.allPrograms,
    state.allTransactionNo,
    state.allEnrolmentNo,
    state.firstRowIndex,
    state.lastRowIndex,
    state.searchFieldValue,
    state.isOpen,
    state.expanded,
    state.background,
    state.programsSelectedList,
    state.enrolmentNoSelectedList,
    state.transactionNoSelectedList    
  ]);

  const paidCommissionsFn = (startDate, endDate) => {
    setState((prevState) => ({
      ...prevState,
      hidden: "",
      isLoaded: true
    }));
    agentsRequests.paymentRecord(startDate, endDate).then((result) => {
      if (result !== "error") {
        setState((prevState) => ({
          ...prevState,
          pCommissionsData: result,
        }));
      }

      setState((prevState) => ({
        ...prevState,
        hidden: "hidden",
        isLoaded: false
      }));
    });
  };

  const loadMultiSelectData = () => {
    let allPrograms = [];
    let allTransactionNo = [];
    let allEnrolmentNo = [];

    let data = state.pCommissionsData;
    if (Array.isArray(data)) {
      data?.map((object) => {
        if (allPrograms.some((item) => object.programName === item)) {
        } else {
          allPrograms.push(object.programName);
        }
      });

      data?.map((object) => {
        if (allTransactionNo.some((item) => object.paymentNo === item)) {
        } else {
          allTransactionNo.push(object.paymentNo);
        }
      });

      data?.map((object) => {
        if (allEnrolmentNo.some((item) => object.enrolmentNo === item)) {
        } else {
          allEnrolmentNo.push(object.enrolmentNo);
        }
      });
    }
    setState((prevState) => ({
      ...prevState,
      allPrograms: allPrograms,
      allTransactionNo: allTransactionNo,
      allEnrolmentNo: allEnrolmentNo,
    }));
  };

  const loadData = () => {
    let tableRows = [];
    let formatedRowData = {};
    let data = state.pCommissionsData;
    let firstRowIndex = state.firstRowIndex;
    let lastRowIndex = state.lastRowIndex;

    data = searchItems(data);

    data = dataProcessor(data);

    let dataLength = data?.length;
    if (dataLength < parseInt(firstRowIndex) + 1) {
      firstRowIndex = 0;
      lastRowIndex = constants.NUMBEROFROWS - 1;
    }

    if (data != "" && data != null && data.length > 0) {
      data?.map((object, index) => {
        if (index >= firstRowIndex && index <= lastRowIndex) {
          formatedRowData.ImgSrc =
            "https://ui-avatars.com/api/name=" +
            object.studentName +
            "/?background=random";
          formatedRowData.Label1 = object.studentName;
          formatedRowData.DescriptionClm1 =
            " Student Number : " + object.studentNo;
          formatedRowData.Label2 = object.programName;
          formatedRowData.DescriptionClm2 =
            "Enrolment Number: " + object.enrolmentNo;
          formatedRowData["Payment No"] = object.paymentNo;
          // let transactionDate = new Date(object.transactionDate);

          formatedRowData["Payment Date"] = object.transactionDate;
          formatedRowData.Value = "$" + currencyFormat(object.paidAmount);
          tableRows.push({ ...formatedRowData });
        }
      });
    } else {
      //following line will unhide Nodata View
      setState((prevState) => ({
        ...prevState,
        tableEmpty: "",
      }));
    }
    setState((prevState) => ({
      ...prevState,
      tableRows: tableRows,
    }));
  };

  const dataProcessor = (data) => {
    let programsSelectedList = state.programsSelectedList;
    let transactionNoSelectedList = state.transactionNoSelectedList;
    let enrolmentNoSelectedList = state.enrolmentNoSelectedList;

    if (programsSelectedList != "") {
      data = multiselectFilter(data, programsSelectedList, "programName");
    }
    if (transactionNoSelectedList != "") {
      data = multiselectFilter(data, transactionNoSelectedList, "paymentNo");
    }
    if (enrolmentNoSelectedList != "") {
      data = multiselectFilter(data, enrolmentNoSelectedList, "enrolmentNo");
    }

    // following line of code will set dataLength
    setState((prevState) => ({
      ...prevState,
      dataLength: data.length,
    }));
    return data;
  };

  const searchItems = (data) => {
    let originalData = data;
    let searchValue = state.searchFieldValue;
    if (searchValue != "") {
      data = data.filter((object) =>
        object.studentName.toUpperCase().includes(searchValue.toUpperCase())
      );
      setState((prevState) => ({
        ...prevState,
        filterOn: true,
      }));

      if (data.length === originalData.length) {
        setState((prevState) => ({
          ...prevState,
          filterOn: false,
        }));
      }
    }
    setState((prevState) => ({
      ...prevState,
      dataLength: data.length,
    }));

    return data;
  };

  const renderTable = () => {
    let tableHeadings = [
      "Student Details",
      "Enrolment Details",
      "Payment No",
      "Payment Date",
      "Paid Amount",
      "",
    ];
    let tableRows = state.tableRows;

    return (
      <TableComponent
        tableHeadings={tableHeadings}
        tableRows={tableRows}
        filterOn={state.filterOn}
        numberOfElementsPerPage={constants.NUMBEROFROWS}
        dataLength={state.dataLength}
        setPageIndexFn={setPageIndexFn}
        firstRowIndex={state.firstRowIndex}
        lastRowIndex={state.lastRowIndex}
        clmTwoWidth={"w-1/4"}
      />
    )
  };

  const setPageIndexFn = (firstRowIndex, lastRowIndex) => {
    setState((prevState) => ({
      ...prevState,
      firstRowIndex: firstRowIndex,
      lastRowIndex: lastRowIndex,
    }));
  };

  const searchHandeler = () => {
    var searchValue = document.getElementById("search").value;
    setState((prevState) => ({
      ...prevState,
      searchFieldValue: searchValue,
    }));
  };

  const filtersDropdown = () => {
    let expanded = state.expanded;
    if (expanded) {
      setState((prevState) => ({
        ...prevState,
        isOpen: false,
        expanded: "",
        background: "hidden",
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        isOpen: true,
        expanded: "yes",
        background: "",
      }));

      document.getElementById("search").value = state.searchFieldValue;
    }
  };

  const handleDateBox = (e, name) => {
    localStorage.setItem("dateRangeLabel8", "Custom Range");
    let selectedDate = e;

    let fromDate = new Date(dateFormatter.formatterThree(state.fromDate));
    let toDate = new Date(dateFormatter.formatterThree(state.toDate));
    let sDate = new Date(dateFormatter.formatterThree(selectedDate));

    if (name === "FromDate") {
      let startDate = dateFormatter.formatterTwo(sDate);
      let endDate = dateFormatter.formatterTwo(toDate);
      localStorage.setItem("t8StartDate", startDate);

      setState((prevState) => ({
        ...prevState,
        fromDate: startDate,

        isOpen: false,
        expanded: "",
        background: "hidden",
      }));

      // window.location.reload();
    } else if (name === "ToDate") {
      let startDate = dateFormatter.formatterTwo(fromDate);
      let endDate = dateFormatter.formatterTwo(sDate);
      localStorage.setItem("t8EndDate", endDate);

      setState((prevState) => ({
        ...prevState,
        toDate: endDate,
        isOpen: false,
        expanded: "",
        background: "hidden",
      }));
    }
  };

  const closeAdvSearch = () => {
    setState((prevState) => ({
      ...prevState,
      isOpen: false,
      expanded: "",
      background: "hidden",
    }));
  };

  const onMultiSelectChange = (selectedList, item, id) => {
    if (id === "program") {
      setState((prevState) => ({
        ...prevState,
        programsSelectedList: selectedList,
      }));
    } else if (id === "transactionNo") {
      setState((prevState) => ({
        ...prevState,
        transactionNoSelectedList: selectedList,
      }));
    } else if (id === "enrolmentNo") {
      setState((prevState) => ({
        ...prevState,
        enrolmentNoSelectedList: selectedList,
      }));
    }
  };

  // --- CSV DOWNLOAD HANDLER ---
  const handleDownload = () => {
    // 1. Get current data and apply active search and multiselect filters
    let data = [...state.pCommissionsData];
    data = searchItems(data);
    data = dataProcessor(data);

    if (!data || data.length === 0) {
      alert("No data available to download.");
      return;
    }

    // 2. Define headers based on your renderTable columns
    const headers = [
      "Student Name",
      "Student No",
      "Program",
      "Enrolment No",
      "Payment No",
      "Payment Date",
      "Paid Amount"
    ];

    // 3. Define the exact keys in pCommissionsData that map to the headers
    const keys = [
      "studentName",
      "studentNo",
      "programName",
      "enrolmentNo",
      "paymentNo",
      "transactionDate",
      "paidAmount"
    ];

    // 4. Set the dynamic file name
    const fileName = `Paid_Commissions_${moment().format("DD-MM-YYYY")}`;

    // 5. Call our reusable download helper!
    downloadCSV(data, headers, keys, fileName);
  };

  const renderAdvancedSearch = () => {
    return (
      <div className="w-full">
        <div className="md:mt-5 mt-1 flex xl:justify-end">
          <button
            onClick={() => filtersDropdown()}
            className={`focus:outline-none text-white hover:bg-blue-800 dark:ring-0 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 ${state.isOpen ? "bg-blue-700 text-white dark:bg-white/20" : "bg-blue-500 hover:dark:bg-white/20 dark:bg-white/10 dark:text-white"}`}
          >
            Advanced Search
          </button>
        </div>
        {state.isOpen && (
          <div className="w-full mt-1 ">
            <div className="pb-4">
              <div className="text-gray-600 w-full flex justify-between items-center mb-4">
                {/* <h1 className="font-semibold text-lg">Advanced Filters</h1> */}
                {/* <p className="cursor-pointer text-xl font-bold" onClick={closeAdvSearch}>
                  &times;
                </p> */}
              </div>
                <div className=" grid grid-cols-6 gap-6">
                  <div className="md:py-3 col-span-6 md:col-span-2 ">
                    <MultiSelection
                      id="program"
                      label="Select Programs"
                      selectedValues={state.programsSelectedList}
                      data={state.allPrograms}
                      onSelect={(selectedList, selectedItem) =>
                        onMultiSelectChange(
                          selectedList,
                          selectedItem,
                          "program"
                        )
                      }
                      onRemove={(selectedList, removedItem) =>
                        onMultiSelectChange(
                          selectedList,
                          removedItem,
                          "program"
                        )
                      }
                    />
                  </div>
                  <div className="md:py-3 col-span-6 md:col-span-2 ">
                    <MultiSelection
                      id="transactionNo"
                      label="Select Transaction Number"
                      selectedValues={state.transactionNoSelectedList}
                      onSelect={(selectedList, selectedItem) =>
                        onMultiSelectChange(
                          selectedList,
                          selectedItem,
                          "transactionNo"
                        )
                      }
                      onRemove={(selectedList, removedItem) =>
                        onMultiSelectChange(
                          selectedList,
                          removedItem,
                          "transactionNo"
                        )
                      }
                      data={state.allTransactionNo}
                      placeholder="Select"
                    />
                  </div>
                  <div className="md:py-3 col-span-6 md:col-span-2 ">
                    <MultiSelection
                      id="enrolmentNo"
                      label="Select Enrolment Number"
                      selectedValues={state.enrolmentNoSelectedList}
                      onSelect={(selectedList, selectedItem) =>
                        onMultiSelectChange(
                          selectedList,
                          selectedItem,
                          "enrolmentNo"
                        )
                      }
                      onRemove={(selectedList, removedItem) =>
                        onMultiSelectChange(
                          selectedList,
                          removedItem,
                          "enrolmentNo"
                        )
                      }
                      data={state.allEnrolmentNo}
                      placeholder="Select"
                    />
                  </div>
                </div>
              </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="relative mt-4 align-middle min-h-full">
      {/* <span
          className={
           state.hidden +
            " fixed top-10 left-0 right-0 bottom-0 h-full w-full bg-white opacity-25"
          }
        /> */}
      <Loader loaded={state.isLoaded} hidden={state.hidden}></Loader>       

      <div className="col-span-6 flex justify-between items-center mb-4">
        <div className="text-left text-2xl text-blue-500 font-semibold dark:text-white">
          Paid Commissions Listing
        </div>
        {state.pCommissionsData.length>0 && (
          <button
            onClick={handleDownload}
            className="group flex items-center gap-2 px-4 py-2 text-sm font-semibold text-white transition-all duration-300 ease-out bg-gradient-to-br from-emerald-400 to-emerald-600 rounded-lg shadow-md shadow-emerald-500/30 hover:shadow-lg hover:shadow-emerald-500/50 hover:-translate-y-0.5 border border-emerald-400/20 active:scale-95 active:translate-y-0"
            title="Download as CSV"
          >
            <svg
              className="w-4 h-4 transition-transform duration-300 group-hover:-translate-y-0.5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.5}
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
              />
            </svg>
            Download CSV
          </button>
        )}
        
      </div>

      <div className="rounded-md p-4 bg-white mb-4 md:mb-8 w-full grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-6 dark:bg-white/10 shadow-md">
        <div className="xl:col-span-2">
          <SearchBox
            id={"search"}
            label={"Search For Student Name"}
            svgType={"student"}
            placeholder={"Name"}
            value={state.searchFieldValue}
            searchHandler={() => {
              searchHandeler();
            }}
          />
        </div>

        <div className="xl:col-span-2">
          <DateBox
            dependentOn={true}
            id={"Td1"}
            label="Transaction Date From"
            //minDate={moment().add(0, "days").toDate()}
            onChange={handleDateBox}
            name={"FromDate"}
            value={state.fromDate ? new Date(state.fromDate) : ""}
          />
        </div>
        <div className="xl:col-span-2">
          <DateBox
            dependentOn={true}
            id={"Td1"}
            label="Transaction Date Till"
            //minDate={moment().add(0, "days").toDate()}
            onChange={handleDateBox}
            name={"ToDate"}
            value={state.toDate ? new Date(state.toDate) : ""}
            //onChange={handleChange}
          />
        </div>
        <div className="xl:col-span-6">{renderAdvancedSearch()}</div>
      </div>

      <div>{renderTable()}</div>
    </div>
  );
}

export default PaymentRecordView;
